import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

interface AdminCustomersTab {
  labelKey: string;
  icon: string;
  routerLink: string;
}

@Component({
  standalone: true,
  selector: 'app-admin-customers',
  templateUrl: './admin-customers.component.html',
  styleUrls: ['./admin-customers.component.scss'],
  imports: [CommonModule, TranslateModule, RouterModule],
})
export class AdminCustomersComponent {
  public items: AdminCustomersTab[] = [
    {
      labelKey: 'ADMIN.CUSTOMERS.ALL',
      icon: 'fas fa-list',
      routerLink: '/administration/customers',
    },
    {
      labelKey: 'ADMIN.CUSTOMERS.ADD',
      icon: 'fas fa-plus',
      routerLink: '/administration/customers/new',
    },
  ];
}
